import _ from 'lodash';
import moment from 'moment';
import getter from './objectUtils/getter';
import { getMonthFromDateObject } from './date';
import { APP_URL } from '../config';
import { CurrentUser } from '../interfaces/currentUser';

export const goToMainAppHome = () => {
  window.location.href = `${APP_URL}home`;
};

export const checkAdmin = (role) => {
  let isAdmin = false;
  if (role && role.find((rol) => rol === 'Admin' || rol === 'Owner')) {
    isAdmin = true;
  }
  return isAdmin;
};

export const checkSuperAdmin = (user: Partial<CurrentUser>) => {
  let isAdmin = false;
  if (user) {
    isAdmin = checkAdmin(user.role);
  }
  if (isAdmin && user.email) {
    isAdmin = /@joinassembly\.com|@carrothr\.com/.test(user.email);
  }
  return isAdmin;
};

export const hasRewardsPayments = (employer: unknown) => {
  if (!employer) {
    return false;
  }
  const isChargeable =
    getter(['accounts', 'rewards', 'isChargeable'], employer) || false;
  return isChargeable;
};

export const checkIfProduction = () =>
  process.env.REACT_APP_STAGE === 'production';

export const getAllowanceTypeLiteralForUser = (user: CurrentUser) => {
  const allowanceType = _.get(user, ['profile', 'allowanceType'], '');
  if (allowanceType === 'regular') {
    return 'Default';
  }
  if (allowanceType === 'custom') {
    return 'Custom';
  }
  return 'No Allowance';
};

export const getUserStatusTypeLiteralForUser = (user: CurrentUser) => {
  return _.get(user, ['profile', 'status'], 'normal');
};

export const getUserBirthday = (user) => {
  if (user.profile.birthday) {
    const birthDay = user.profile.birthday.date;
    const birthMonth = getMonthFromDateObject(user.profile.birthday);
    if (birthDay && birthMonth) {
      return `${birthMonth}, ${birthDay}`;
    }
  }

  return 'NA';
};

export const getUserAnniversary = (user) => {
  if (user.profile.hiredday) {
    const hireDay = user.profile.hiredday.date;
    const hireMonth = getMonthFromDateObject(user.profile.hiredday);
    const hireYear = user.profile.hiredday.year;
    if (hireDay && hireMonth && hireYear) {
      return moment(
        `${hireMonth} ${hireDay} ${hireYear}`,
        'MMMM D YYYY',
      ).format('MM/D/YYYY');
    }
  }
  return 'NA';
};
